import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import auth from './auth'
import mobile from './mobile'
import i18n from './i18n'

//styles
import './scss/main.scss'

Vue.config.productionTip = false

Vue.use(http)
Vue.use(auth)
Vue.use(mobile)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
